import React, { ReactNode } from 'react';
import { Modal as Dialog } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import styles from './index.module.scss';

interface AlarmModalProps extends ModalProps {
  size?: 'sm' | 'lg' |'bg'//default sm
  height?: string
  width?: number
  top?: string
}

const Modal:React.FC<AlarmModalProps> = (props) => {
  const { size = 'sm' } = props;
  return (
    <Dialog
      {...props}
      className={`${styles.alarm_modal} ${styles.alarm_modal_bg}`}
      style={{height: props.height || '517px',top: props.top || `calc(50% - 270px)`}}
      width={props.width || 800}
      footer={null}
      closeIcon={<img src="/img/icon_close.png" alt="" className={styles.alarm_close} />}
      maskStyle={{background: 'transparent'}}
    >
      {props.children}
    </Dialog>
  )
}

export default Modal;